import { useState } from 'react';
import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import IconSend from '@/icons/Send.svg';
import useViewPort from '@/utils/useViewport';

import { UserDialog } from './UserDialog';

export const InviteUser = () => {
  const { isMobile, isTablet } = useViewPort();
  const isMobileOrTablet = isMobile || isTablet;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant="secondary"
        size={isMobileOrTablet ? 'large' : 'medium'}
        onPress={() => setIsOpen(true)}
        iconOnly={isMobileOrTablet}
      >
        <IconSend />
        {!isMobileOrTablet && (
          <Trans id="settings.users.invite-modal.trigger">Invite new member</Trans>
        )}
      </Button>
      <UserDialog isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
